import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Divider,
  Typography,
  IconButton,
  Box,
  Button,
  Grid,
  CircularProgress
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

export default function DetailsModal({ open, handleClose, societe }) {
  if (!societe) {
    return null;
  }

  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="md">
      <DialogTitle sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <Typography variant="h6" sx={{ fontWeight: 400, mr: 3 }}>
          DÉTAILS DE LA SOCIÉTÉ
        </Typography>
        <IconButton onClick={handleClose}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <Divider />
      <DialogContent>
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={4}>
            <Typography variant="subtitle2" fontWeight="bold">Logo</Typography>
          </Grid>
          <Grid item xs={8}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              {societe.Logo ? (
                <img 
                  src={`http://stjg-backend.test/api/societes/${societe.ID_Societe}/logo`} 
                  alt="Logo" 
                  style={{ width: 100, height: 100, objectFit: "contain" }} 
                />
              ) : (
                <Typography variant="body2" color="text.secondary">Aucun logo</Typography>
              )}
            </Box>
          </Grid>
          <Grid item xs={4}><Typography variant="subtitle2" fontWeight="bold">Nom</Typography></Grid>
          <Grid item xs={8}><Typography>{societe.name || '-'}</Typography></Grid>
          <Grid item xs={4}><Typography variant="subtitle2" fontWeight="bold">Téléphone</Typography></Grid>
          <Grid item xs={8}><Typography>{societe.Téléphone || '-'}</Typography></Grid>
          <Grid item xs={4}><Typography variant="subtitle2" fontWeight="bold">Email</Typography></Grid>
          <Grid item xs={8}><Typography>{societe.email || '-'}</Typography></Grid>
          <Grid item xs={4}><Typography variant="subtitle2" fontWeight="bold">Adresse</Typography></Grid>
          <Grid item xs={8}><Typography>{societe.adresse || '-'}</Typography></Grid>
          <Grid item xs={4}><Typography variant="subtitle2" fontWeight="bold">Site Web</Typography></Grid>
          <Grid item xs={8}><Typography>{societe.website || '-'}</Typography></Grid>
          <Grid item xs={4}><Typography variant="subtitle2" fontWeight="bold">Type de réservation</Typography></Grid>
          <Grid item xs={8}><Typography>{societe.type_reservations || '-'}</Typography></Grid>
          <Grid item xs={4}><Typography variant="subtitle2" fontWeight="bold">Délai de réservation</Typography></Grid>
          <Grid item xs={8}><Typography>{societe.Deadline || '-'}</Typography></Grid>
          <Grid item xs={4}><Typography variant="subtitle2" fontWeight="bold">Statut</Typography></Grid>
          <Grid item xs={8}><Typography>{societe.Status === 1 || societe.Status === '1' || societe.Status === 'Actif' ? 'Actif' : 'Inactif'}</Typography></Grid>
          <Grid item xs={4}><Typography variant="subtitle2" fontWeight="bold">Position</Typography></Grid>
          <Grid item xs={8}><Typography>{societe.Position || '-'}</Typography></Grid>
        </Grid>
      </DialogContent>
      <Divider sx={{ mb: 1 }} />
      <DialogActions sx={{ display: "flex", justifyContent: "flex-end" }}>
        <Button variant="outlined" sx={{ color: "red", borderColor: "red", textTransform: "none", "&:hover": { backgroundColor: "red", color: "#fff", borderColor: "red" } }} onClick={handleClose}>
          Fermer
        </Button>
      </DialogActions>
    </Dialog>
  );
}
